<template>
    <div class="integralDetailsPage">
        <headerNotice routerName="积分流水统计"></headerNotice>
        <!-- 搜索条 -->
        <div class="searchBox">
            <el-form
                :inline="true"
                :model="integralDetailsSearchForm"
                class="demo-form-inline searchForm"
            >
                <el-form-item label="客户名称">
                    <el-input
                        v-model="integralDetailsSearchForm.Word"
                        clearable
                        placeholder="请输入客户名称"
                    >
                        <el-button
                            type="primary"
                            slot="append"
                            icon="el-icon-search"
                            @click="onSearch"
                        ></el-button>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <!-- 搜索结果列表 -->
        <div class="searchList">
            <div class="searchListContent">
                <el-table
                    ref="searchListTable"
                    :data="integralDetailsTableData"
                    style="width: 100%"
                    border
                    v-loading="loading"
                >
                    <el-table-column align='center' type="index" label="序号" width="50"></el-table-column>
                    <el-table-column align='center' prop="customerName" label="客户名称"></el-table-column>
                    <el-table-column align='center' prop="linkman" label="联系人"></el-table-column>
                    <el-table-column align='center' prop="phone" label="手机"></el-table-column>
                    <el-table-column align='center' prop="integral" label="积分">
                        <template slot-scope="scope">
                            <span
                                class="detialSpan"
                                @click="onIntegralDetial(scope.row,scope.$index)"
                            >{{scope.row.integral}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--搜索列表分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            maxResultCount: 10, //默认一页显示的个数,
            currentPage: 1,
            baseUrl: this.$store.state.ossUrl,
            integralDetailsSearchForm: {//搜索表单
                Word: ''
            },
            integralDetailsTableData: [],//表单数据

        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        });
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetStatisticsByIntegral",
                params: params,
                success(res) {
                    self.integralDetailsTableData = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    console.log(res);
                    self.loading = false;
                }
            })
        },
        // 跳转积分明细
        onIntegralDetial(row) {
            console.log(row);
            sessionStorage.setItem('moneyDetialForm', JSON.stringify(row));
            this.$router.push({
                'path': '/amountOfAdvanceDepositDetails',
                'query': {
                    goodsId: 'integral',
                    userId: row.userID
                }
            })
        },
        //搜索
        onSearch(params) {
            let self = this;
            let form = this.integralDetailsSearchForm;
            form.SkipCount = 0
            this.getDatas(form);
            this.currentPage = 1
        },
        //搜索列表一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //搜索列表跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.integralDetailsSearchForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
.integralDetailsPage {
    //搜索框
    .searchBox {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchForm {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 20px;
            .el-form-item {
                margin-bottom: 0;
            }
        }
    }
    //搜索列表
    .searchList {
        margin: 20px 50px;
        border: 1px solid #c5c5c5;
        .searchListHead {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            padding-left: 20px;
            background: #efefef;
            border-bottom: 1px solid #c5c5c5;

            .searchListCtl {
                button,
                .el-select {
                    width: 130px;
                    margin-left: 10px;
                }
            }
        }
        .searchListContent {
            .detialSpan {
                color: #ff9400;
                cursor: pointer;
            }
            .integralColor {
                color: #3498db;
                // cursor: pointer;
            }
        }
    }
}
</style>
